// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ampm-inside-switch .left[data-v-369ea330]{position:relative;top:-3px;left:6px;font-size:12px}.ampm-inside-switch .right[data-v-369ea330]{position:relative;top:-3px;left:23px;font-size:12px}.ampm-inside-switch.left[data-v-369ea330]:after{left:5px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
